import QuestionBlock from "../components/QuestionBlock";
import SectionCard from "../components/SectionCard";
import "../styles/style.css";

export default function Step3({ data, onChange, onNext, onBack }) {

  const isValid =
    data.fonteRenda &&
    data.rendaMensal &&
    data.beneficio &&
    data.ocupacao;

  return (
    <>
    <SectionCard
          title="Renda e Condições de Trabalho"
          description="Responda às perguntas abaixo com atenção. Suas respostas são confidenciais e serão utilizadas exclusivamente para fins educacionais."
          items={[
            { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
          ]}
        > </SectionCard>

      <QuestionBlock
        name="fonteRenda"
        title="Qual é a principal fonte de renda da sua família?"
        subtitle="(Resposta única)"
        options={[
          "Trabalho formal (carteira assinada)",
          "Trabalho informal / autônomo",
          "Benefícios sociais (ex.: Bolsa Família, BPC)",
          "Aposentadoria / pensão"
        ]}
        selected={data.fonteRenda}
        onSelect={(value) => onChange({ fonteRenda: value })}
      />
        <QuestionBlock
        name="rendaMensal"
        title="Qual é a renda familiar mensal total?"
        subtitle="(Resposta única)"
        options={[
          "Até 1 salário mínimo",
          "1 a 2 salários mínimos",
          "2 a 3 salários mínimos",
          "A cima de 3 salários mínimos"
        ]}
        selected={data.rendaMensal}
        onSelect={(value) => onChange({ rendaMensal: value })}
      />
      <QuestionBlock
        name="beneficio"
        title="Você recebe algum benefício social?"
        subtitle="(Resposta única)"
        options={[
          "Bolsa Família",
          "BPC",
          "Auxílio municipal / estadual",
          "Não recebo nenhum benefício"
        ]}
        selected={data.beneficio}
        onSelect={(value) => onChange({ beneficio: value })}
      />
<QuestionBlock
        name="ocupacao"
        title="Qual é a sua ocupação atual?"
        subtitle="(Resposta única)"
        options={[
          "Trabalho formal (carteira assinada / serviço público)",
          "Trabalho informal / autônomo",
          "Desempregado(a)",
          "Estudante / Dona(o) de casa / Aposentado(a)"
        ]}
        selected={data.ocupacao}
        onSelect={(value) => onChange({ ocupacao: value })}
      />
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>

        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!isValid}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
